import {financingEndingApi, type ListFinancingEndingBulkOperationItemsApiArg} from '@dms/api/sales';

export type FinancingEndingOperationItemsPageSubscriptionProps = {
  pageArg: ListFinancingEndingBulkOperationItemsApiArg;
  pollingInterval: number;
};

/**
 * Keeps one loaded items page in the cache and polls it at the given interval. The subscription and
 * its polling end when the component unmounts.
 */
export function FinancingEndingOperationItemsPageSubscription(
  props: FinancingEndingOperationItemsPageSubscriptionProps
) {
  financingEndingApi.endpoints.listFinancingEndingBulkOperationItems.useQuerySubscription(
    props.pageArg,
    {pollingInterval: props.pollingInterval}
  );

  return null;
}
